import React, { useEffect } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import GenesSearch from './GenesSearch'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import PreDesignedControl from './PreDesignedControl'
import PreDesignedGRNA from './PreDesignedGRNA'
import ErrorAlert from '../../../../Configurators/components/ErrorAlert'
import { semiConfigContext, ProductDetails } from '../Crisprgna'
import GrnaResultSet from './GrnaResultSet'
import ControlsResultSet from './ControlsResultSet'
import Paper from '@material-ui/core/Paper'
import PerformanceGuaranteePopUp from '@src/routes/SemiConfigurators/components/PopUp/PerformanceGuaranteePopUp'
import { Grid } from '@material-ui/core'
import { SemiConfigPropertyValues } from '../../../utils/constants'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'justify',
  },
  divider: {
    height: 350,
    marginTop: theme.spacing(20),
    width: 1,
    marginLeft: theme.spacing(8),
  },
  fontSize2: {
    fontSize: theme.typography.pxToRem(12),
  },
  heading: {
    fontSize: theme.typography.pxToRem(20),
    padding: theme.spacing(2, 0),
    fontWeight: theme.typography.fontWeightBold,
  },
  errorMsgStyle: {
    textAlign: 'left',
    fontSize: theme.typography.pxToRem(16),
    borderRadius: theme.spacing(0),
    padding: theme.spacing(6, 0, 6, 0),
  },
  recommendationText: {
    position: 'relative',
    padding: theme.spacing(0, 0, 4, 0),
  },
}))

interface ItemSelectionProps {
  productDetails: ProductDetails
}

const ItemSelection: React.FC<ItemSelectionProps> = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const { productDetails } = props
  const [open, setOpen] = React.useState(false)
  const { state } = React.useContext(semiConfigContext)
  const [message, setMessage] = React.useState('')
  const maxItems = SemiConfigPropertyValues.MaximumItemsAllowed
  const { searchResponseJson } = state
  const onNext = (dropDownResult, params) => {
    if (state.priceCallData.reagents.length === 0) {
      setMessage(intl.formatMessage(messages.CONF_GRNA_ERROR_POPUP_crispgrna))
      setOpen(true)
      window.scrollTo(0, 0)
    } else if (state.priceCallData.reagents.length > 500) {
      setMessage(
        intl.formatMessage(messages.SEMICONF_MAX_ITEMS_ALLOWED, { maxItems })
      )
      setOpen(true)
      window.scrollTo(0, 0)
    } else {
      dropDownResult(params)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div>
      <ErrorAlert open={open} setOpen={setOpen} message={message} />
      <h2 className={classes.heading}>
        {' '}
        {
          <FormattedMessage
            {...messages.CONF_Crispr_Search_Criteria_crisprgrna}
          />
        }
      </h2>
      <Grid item xs={6} className={classes.recommendationText}>
        <PerformanceGuaranteePopUp />
      </Grid>
      <GenesSearch />
      <h2 className={classes.heading}>
        {' '}
        {
          <FormattedMessage
            {...messages.CONF_Pre_Designed_Control_crisprgrna}
          />
        }
      </h2>
      {!searchResponseJson.controls.length ? (
        <>
          <Paper className={classes.errorMsgStyle}>
            <div>
              <FormattedMessage
                {...messages.SEMICONF_NO_RECORDS_MSG_crisprgrna}
              />
            </div>
          </Paper>
        </>
      ) : (
        <>
          <ControlsResultSet />
          <PreDesignedControl />
        </>
      )}
      <div id="predesignedgRNAsResultsSection" />
      <h2 className={classes.heading}>
        {' '}
        {<FormattedMessage {...messages.CONF_Pre_Designed_gRNA_crisprgrna} />}
      </h2>
      {!searchResponseJson.reagents.length ? (
        <>
          <Paper className={classes.errorMsgStyle}>
            <div>
              <FormattedMessage
                {...messages.SEMICONF_NO_RECORDS_MSG_crisprgrna}
              />
            </div>
          </Paper>
        </>
      ) : (
        <>
          <GrnaResultSet />
          <PreDesignedGRNA onNext={onNext} productDetails={productDetails} />
        </>
      )}
    </div>
  )
}

export default ItemSelection
